import React, { useEffect, useState } from 'react'
import Footer from "../components/Footer";
import "./css/thankspage.css";
import { clearCart } from '../slices/signUp';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getCall } from '../utils/Network';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
 
const PortalUrl = process.env.REACT_APP_PORTAL_URL;
 
// Thank Page component
 
const ThankPage = () => {
 
  const { t } = useTranslation();
  const params = useParams();
  const [order, setOrder] = useState(null);
  const token = useSelector((state) => state.signup.token);
  const bearerHeaders={"Authorization" : "Bearer " + token }
 
    useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
  },[])
 
  // Get Order Function
  async function getOrder(id) {
    const response = await getCall({ url: 'getCompleteOrderDetails', urlParams: { orderNumber: id }, header: bearerHeaders });
   
    if (response?.data) {
      setOrder(response?.data)
    }
  }
 
  useEffect(() => {
   
    getOrder(params.orderId);
   
  }, []);
 
  const dispatch = useDispatch();
 
 useEffect(() => {
  dispatch(clearCart());
}, [dispatch]);
 
  const fnNavigate = ()=>{
    window.open(PortalUrl, '_blank');
  }
 
 
   
  return (
    <div className='theme-bg'>
      <Navbar/>
    <div className='thankyou-page '>
 
        <div className="container">
            <div className="thank-content">
              <div className='title-head-btn'>
                <h3 className='order-title'>{t('order')} {params.orderId}</h3>
                {/* <button className="theme-btn" style={{width: '200px', height:'44px'}} onClick={fnNavigate}>{t('eaconomyPortal')}</button> */}
                    <div className="primary-button-wrapper">
                        <a href='#'  onClick={fnNavigate}
                          data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6" className="primary-button w-inline-block">
                          <div className="primary-button-border-wrap">
                            <div className="primary-button-wrap">
                              <div className="primary-button-text">{t('eaconomyPortal')}</div>
                              <div className="primary-button-hover-text">{t('eaconomyPortal')}</div>
                              <div className="primary-button-hover-bg"></div>
                            </div>
                          </div>
                          <div className="line-wrap">
                            <div className="primary-line-wrap _1">
                              <div className="line _1"></div>
                              <div className="line _2"></div>
                            </div>
                            <div className="primary-line-wrap _2">
                              <div className="line _3"></div>
                              <div className="line _4"></div>
                            </div>
                            <div className="primary-line-wrap _3">
                              <div className="line _5"></div>
                              <div className="line _6"></div>
                            </div>
                            <div className="primary-line-wrap _4">
                              <div className="line _7"></div>
                              <div className="line _8"></div>
                            </div>
                          </div>
                        </a>
                      </div>
                </div>
                <table className="table-main">
                  <thead>
                    <tr>
                      <th colSpan={1}>{t('product')}</th>
                      <th className="text-center">{t('qnt')}</th>
                      <th className="text-end" >{t('unit')}</th>
                      <th className="text-end">{t('amount')}</th>
                    </tr>
                  </thead>
                  <tbody className='table-body'>
                    {order?.orderDetails && order?.orderDetails.map((item) => {
                      return <tr key={item.itemId}>
                        <td>
                          <p className="mb-1">{item.productName}</p>
                        </td>
                        <td className="text-center">{item.quantity}</td>
                        <td className="text-end">{item.amount.toLocaleString("en-US", { style: 'currency', currency: item?.currencyCode ?? 'USD' })}</td>
                        <td className="text-end">{item.amount.toLocaleString("en-US", { style: 'currency', currency: item?.currencyCode ?? 'USD' })}</td>
                      </tr>
                    })}
 
                    <tr>
                      <td colSpan="3" className="strong text-end">{t('subtotal')}</td>
                      <td className="text-end">{order?.subTotal?.toLocaleString("en-US", { style: 'currency', currency: order?.currencyCode ?? 'USD' })}</td>
                    </tr>
                    <tr>
                      <td colSpan="3" className="strong text-end">{t('shipping')}</td>
                      <td className="text-end">{order?.shipping?.toLocaleString("en-US", { style: 'currency', currency: order?.currencyCode ?? 'USD' })}</td>
                    </tr>
                    <tr>
                      <td colSpan="3" className="strong text-end">{t('tax')} </td>
                      <td className="text-end">{order?.tax?.toLocaleString("en-US", { style: 'currency', currency: order?.currencyCode ?? 'USD' })}</td>
                    </tr>
                    <tr>
                      <td colSpan="3" className="font-weight-bold text-uppercase text-end">{t('invoiceTotal')}</td>
                      <td className="font-weight-bold text-end">{order?.total?.toLocaleString("en-US", { style: 'currency', currency: order?.currencyCode ?? 'USD' })}</td>
                    </tr>
                  </tbody>
                </table>
 
            </div>
        </div>
        <Footer/>
    </div>
    </div>
  )
}
 
export default ThankPage